"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.table.shortcut': 'Skrót',
    'shortcuts.table.description': 'Opis',
};
